import React, { memo } from "react";
import { TextField } from "@material-ui/core";
import { hot } from "react-hot-loader";
import shortId from "shortid";

const ShortId = ({ value, type, label, hidden, onChange }) => {
  const val = value || shortId.generate();
  if (!value) {
    setTimeout(() => onChange({ target: { value: val } }), 1000);
  }

  return (
    <TextField
      fullWidth
      readOnly
      disabled
      label={label}
      value={val}
      type={type}
      onChange={onChange}
      margin="none"
    />
  );
};

export default memo(hot(module)(ShortId), () => true);
